exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-container[data-v-ad4158e6] .el-textarea__inner {\n  padding-right: 55px !important;\n  max-height: 100px !important;\n}\n", ""]);

// exports
